Vendd.Scripts.load(function () {
'use strict'

    var actionsMap = {
        'ck-book-service': openBookServiceForm,
        'ck-contact': openContactForm,
        'ck-test-drive': openTestDriveForm,
        'ck-request-quote': openRequestQuoteForm,
        'ck-car-evaluation': openCarEvaluationForm,
    }

    $('.description-container,.extra-info-dealer').on('click', '.ck-form-action', function (evt) {
        var $descriptionContainer = $(evt.delegateTarget);
        if ($descriptionContainer.hasClass('ck-content')) return;
        evt.preventDefault();

        var $this = $(evt.currentTarget);

        for (var prop in actionsMap) {
            if ($this.hasClass(prop)) {
                var func = actionsMap[prop];
                func();
                return;
            }
        }
        
    });

});